import mockHostAppModule from 'src/modules/mockHostApp/module';

export const moduleList = { ...mockHostAppModule };

export const reducerList = {};
